module.exports = __webpack_public_path__ + "static/media/undraw-studying-s-3-l-7.283c7132.svg";